import validateRequiredProps from 'utils/validateRequiredProps';
import {Record} from 'immutable';
import moment from 'moment';

export function validate(entity) {
  return validateRequiredProps(entity, ['id', 'name']);
}

export default class CrmOpportunity extends Record({
  id: null,
  name: null,
  crmAccountId: null,
  accountName: null,
  crmDataId: null,
  crmId: null,
  crmStageId: null,
  crmEngagementType: null,
  clientStageName: null,
  created: null,
}) {
  constructor(object = {}) {
    const created = moment(object.created);
    const opName =
      (object.crmEngagementType === 'CASE' ? 'Case: ' : 'Opportunity: ') +
      object.name +
      ' [' +
      object.accountName +
      '] (' +
      created.format('L') +
      ')';
    super({
      ...object,
      id: object.id || object.crmId,
      name: opName,
      created,
    });
  }
}
